"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");require("core-js/modules/es6.object.keys");require("core-js/modules/web.dom.iterable"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default =
{
  data: function data() {
    return {
      searchData: {
        name: '', //厂商名称
        page: 1,
        rows: 10 },
      //搜索参数
      tableColumns: [
      {
        prop: 'name',
        label: '厂商名称' },

      {
        prop: 'code',
        label: '厂商编码' },

      {
        prop: 'remark',
        label: '备注' }],

      //表格信息
      pageData: {
        page: 1,
        rows: 10,
        total: 0,
        pages: 1 },
      //分页数据
      list: [], //列表数据
      showDialog: false, //是否显示新增||编辑弹窗
      firmForm: {
        id: 0,
        name: '',
        code: '',
        remark: '' },
      //新增||编辑厂商表单
      firmFormRule: {
        name: [{
          required: true,
          message: '请填写厂商名称',
          trigger: ['blur', 'change'] }],

        code: [{
          required: true,
          message: '请填写厂商编码',
          trigger: ['blur', 'change'] }] },

      //表单验证规则
      currentModule: '' //当前编辑的模块
    };
  },

  mounted: function mounted() {
    this.initPage();
  },

  methods: {
    /**
              * 页面初始化
              */
    initPage: function initPage() {
      this.fetchProductionCompanyList();
    },

    /**
        * 获取厂商列表
        */
    fetchProductionCompanyList: function fetchProductionCompanyList() {var _this = this;
      var params = Object.assign({}, this.searchData);
      this.getData('/api/productionCompany', params, function (res) {
        _this.list = res.list;
        _this.pageData.page = res.pageNum;
        _this.pageData.total = res.total;
      });
    },

    /**
        * 重置
        */
    onClickReset: function onClickReset() {
      this.$set(this.searchData, 'name', '');
      this.$set(this.searchData, 'page', 1);
      this.fetchProductionCompanyList();
    },

    /**
        * 每页size-change
        */
    handleSizeChange: function handleSizeChange(val) {
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.fetchProductionCompanyList();
    },

    /**
        * 页码-change
        */
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.fetchProductionCompanyList();
    },

    /**
        * 弹窗关闭-回调
        */
    onDialogClose: function onDialogClose() {var _this2 = this;
      this.$nextTick(function () {
        Object.keys(_this2.firmForm).forEach(function (key) {
          _this2.$set(_this2.firmForm, key, key == 'id' ? 0 : '');
        });
        _this2.$refs.firmForm.clearValidate();
      });
      this.showDialog = false;
      this.currentModule = '';
    },

    /**
        * 保存||新增模块厂商
        */
    onSubmitModuleFirm: function onSubmitModuleFirm() {var _this3 = this;
      this.$refs.firmForm.validate(function (valid) {
        if (valid) {
          var params = Object.assign({}, _this3.firmForm);
          if (params.id) {
            //编辑
            params.createTime = _this3.currentModule.createTime;
            _this3.putData('/api/productionCompany', params, function (res) {
              _this3.onDialogClose();
              _this3.fetchProductionCompanyList();
            });
          } else {
            //新增
            delete params['id'];
            _this3.postData('/api/productionCompany', params, function (res) {
              _this3.onDialogClose();
              _this3.$set(_this3.searchData, 'page', 1);
              _this3.fetchProductionCompanyList();
            });
          }
        }
      });
    },

    /**
        * 编辑
        */
    onClickUpdate: function onClickUpdate(row) {
      this.showDialog = true;
      this.currentModule = Object.assign({}, row);
      this.$set(this.firmForm, 'id', row.id);
      this.$set(this.firmForm, 'name', row.name);
      this.$set(this.firmForm, 'code', row.code);
      this.$set(this.firmForm, 'remark', row.remark);
    },

    /**
        * 删除
        */
    onClickDelete: function onClickDelete(row) {var _this4 = this;
      this.$confirm('确定删除当前厂商？', '提示', { type: 'warning' }).then(function (res) {
        //删除厂商
        _this4.delData('/api/productionCompany', { id: row.id }, function (res) {
          _this4.fetchProductionCompanyList();
        });
      }).catch(function (err) {

      });
    } } };exports.default = _default;